import { PRODUCTS_INDEX, searchClient } from "@/lib/typesense";
import { createRoute, Outlet } from "@tanstack/react-router";
import { InstantSearch } from "react-instantsearch";
import { authRoute } from "./$authRoute";

/**
 * The Typesense provider, one level above the app shell.
 *
 * It used to live inside `layoutRoute`, wrapping `MainLayout`. It was hoisted
 * out when phone search became a route of its own (storefront#158): that page
 * is deliberately *not* inside the shell - it is a full-screen surface with no
 * header, sidebar or sticky cart bar - yet it drives the same query the results
 * page reads. A single provider above both is what lets the buyer type on the
 * search page, hit Enter, and land on `/search` with the query already in
 * flight rather than re-issued from the URL.
 */
export const searchProviderRoute = createRoute({
  getParentRoute: () => authRoute,
  id: "search-provider", // Pathless route - no path property
  component: SearchProvider
});

function SearchProvider() {
  return (
    <InstantSearch
      searchClient={searchClient}
      indexName={PRODUCTS_INDEX}
      // Load-bearing, do not remove: the search page's filter panel is mounted
      // twice below lg (the hidden sidebar + the open drawer share the one
      // refinement state), and this flag is what preserves the refinements when
      // one copy unmounts. Without it, closing the filters drawer on a phone
      // silently unfilters the results. See SearchPage's aside comment.
      //
      // It carries a second load now: navigating between `/search/input` and
      // `/search` unmounts one page's widgets and mounts the other's, and the
      // refinements have to survive that crossing too.
      future={{ preserveSharedStateOnUnmount: true }}
    >
      <Outlet />
    </InstantSearch>
  );
}
